import React from 'react'

import styles from './ContratanteJuridico.module.css'

import Identificacion from '../Identificacion'
import Contacto from '../Contacto'
import Empresa from '../Empresa'
import RepresentanteLegal from '../RepresentanteLegal'
import GerenteAdministrativo from '../GerenteAdministrativo'

const ContratanteJuridico = ({ contratante, state, setState }) => {
    return (
        <React.Fragment>
            <div className={styles['areaduocard']}>
                <Identificacion
                    contratante={contratante}
                    state={state}
                    setState={setState} />
                <Contacto
                    contratante={contratante} 
                    state={state} 
                    setState={setState} />
            </div>

            <Empresa
                contratante={contratante}
                state={state}
                setState={setState} />
            
            <RepresentanteLegal
                contratante={contratante}
                state={state}
                setState={setState} />

            <GerenteAdministrativo
                contratante={contratante}
                state={state}
                setState={setState} />
        </React.Fragment>
    )
}

export default ContratanteJuridico